module.exports = __webpack_public_path__ + "static/media/invite.ff2a8808.png";